export const ROUTES = {
  PAYMENT_PROFILES: "Payment Profiles",
  LOCATION: "Location",
  LINK_PAY: "Payment Links",
  PROFILE_ITEMS: "Profile Items",
  USER_ASSIGNMENT: "User Assignment",
  USERS: "Users",
  DEBUG_LOGS: "Debug Logs",
  MY_ORGANIZATION: "My Organization",
  CATEGORIES: "Categories",
  EVENTS: "Fundraiser Events",
  FUNDRAISER_USERS: "Fundraiser Users",
  DEVICE_REBOOT: "Device Reboot",

  //transaction routes
  INVENTORY_DASHBOARD: "Inventory Dashboard",
  TRANSACTION: "Transaction",
  CARD_PAYMENTS: "Card Payments",
  CASH_PAYMENTS: "Cash Payments",
  FB_PAYMENTS: "FB Payments",
  MEMBERSHIP_PAYMENTS: "Membership/Room Payments",
  TRANSACTION_ITEM_SUMMARY: "Transaction Item Summary",
};

const {
  PAYMENT_PROFILES,
  LOCATION,
  LINK_PAY,
  USER_ASSIGNMENT,
  USERS,
  DEBUG_LOGS,
  PROFILE_ITEMS,
  INVENTORY_DASHBOARD,
  TRANSACTION,
  CARD_PAYMENTS,
  CASH_PAYMENTS,
  FB_PAYMENTS,
  MEMBERSHIP_PAYMENTS,
  TRANSACTION_ITEM_SUMMARY,
  CATEGORIES,
  MY_ORGANIZATION,
  EVENTS,
  FUNDRAISER_USERS,
  DEVICE_REBOOT
} = ROUTES;

//should not select all in the table if route from below array
export const SHOULD_ALLOW_ALL_SELECT = [
  PAYMENT_PROFILES,
  LOCATION,
  LINK_PAY,
  USER_ASSIGNMENT,
  USERS,
  PROFILE_ITEMS
];

//should allow select row in table if route from the below array
export const SHOULD_ALLOW_SELECT = [
  PAYMENT_PROFILES,
  LOCATION,
  USER_ASSIGNMENT,
  PROFILE_ITEMS,
  EVENTS,
  FUNDRAISER_USERS
]

//should allow to display the date picker if route from the below array
export const SHOULD_ALLOW_DATE_PICKER = [
  TRANSACTION,
  MEMBERSHIP_PAYMENTS,
  CARD_PAYMENTS,
  CASH_PAYMENTS,
  FB_PAYMENTS,
  INVENTORY_DASHBOARD,
  TRANSACTION_ITEM_SUMMARY,
];

//should not add empty column in table head
export const RESTRICT_EMPTY_COLUMNS = [
  TRANSACTION_ITEM_SUMMARY,
  DEBUG_LOGS,
  TRANSACTION,
  CARD_PAYMENTS,
  CASH_PAYMENTS,
  FB_PAYMENTS,
  MEMBERSHIP_PAYMENTS,
  DEVICE_REBOOT,
];

//allow to create documents in respective routes (allow add icon in table)
export const ALLOW_CREATE_DOCUMENTS = [
  PAYMENT_PROFILES,
  LOCATION,
  LINK_PAY,
  USER_ASSIGNMENT,
  USERS,
  CATEGORIES,
  PROFILE_ITEMS,
  EVENTS,
  FUNDRAISER_USERS,
];

//should not add checked in table
export const RESTRICT_ROW_SELECT  = [
  TRANSACTION,
  INVENTORY_DASHBOARD,
  TRANSACTION_ITEM_SUMMARY,
  CARD_PAYMENTS,
  CASH_PAYMENTS,
  FB_PAYMENTS,
  MEMBERSHIP_PAYMENTS,
  DEBUG_LOGS,
  DEVICE_REBOOT
]

//should add extra column (exportExcel) related to reversal transaction
export const ALLOW_EXTRA_COLUMN_EXPORT = [
  TRANSACTION,
  CARD_PAYMENTS,
  CASH_PAYMENTS,
  FB_PAYMENTS,
  MEMBERSHIP_PAYMENTS
]

//should allow double click in table row (based on the route)
export const ALLOW_DOUBLE_CLICK_ACTION = [
  USER_ASSIGNMENT,
  PAYMENT_PROFILES,
  LOCATION,
  LINK_PAY,
  USERS,
  PROFILE_ITEMS,
  MY_ORGANIZATION,
  CATEGORIES,
  EVENTS,
  FUNDRAISER_USERS,
];

//should not add chunk based data fetching to export the data
export const RESTRICT_CHUNK_BASED_FETCHING = [
  MY_ORGANIZATION,
  DEBUG_LOGS,
  PROFILE_ITEMS,
  DEVICE_REBOOT
];

//allow unique id from front-end side to render table row
export const ALLOW_ADD_UNIQUE_ID = [
  TRANSACTION_ITEM_SUMMARY,
  INVENTORY_DASHBOARD
];

//restrict excel and csv export (based on route)
export const RESTRICT_EXCEL_CSV_EXPORT = [
  DEVICE_REBOOT
];

//restrict pdf export (based on route)
export const RESTRICT_PDF_EXPORT = [
  DEBUG_LOGS,
  DEVICE_REBOOT,
  ...SHOULD_ALLOW_DATE_PICKER,
]